import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {App} from './App';
import { BrowserRouter } from 'react-router-dom';
import {Router} from './components/Router';
import { Provider } from 'react-redux';
import {store} from './redux/store';
import {GlobalStyle} from './style/GlobalStyle';
import "./js/GlobalFunction"


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <GlobalStyle />
      <BrowserRouter>
      <App />
      <Router />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

